{
    "CYBUS_DOCS": "/",
    "LICENSE_OFFLINE_ACTIVATION": "/documentation/installation-and-upgrades/licensing#offline-license-activation",
    "LICENSING": "/documentation/installation-and-upgrades/licensing",
    "MQTT_PREFIX": "/documentation/user-management/adding-an-mqtt-publish-prefix-for-users",
    "RULE_ENGINE_PARSE_RULE": "/documentation/services/rule-engine/data-processing-rules#parse",
    "SERVICES": "/documentation/services",
    "SERVICES_COMMISSIONING_FILE": "/documentation/services/service-commissioning-files",
    "UI_ACCESS_PERMISSIONS": "/documentation/user-management/access-permissions-for-admin-ui/ui-access"
}
